import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter  } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, message, Table, Tag, Select } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import './Page2.css';

import { DatePicker, Space, Button } from 'antd';

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';


// import axios from 'axios';
const { Option } = Select;
const dateFormat = 'YYYY/MM/DD';
const { Column, ColumnGroup } = Table;



const AdminSettings: React.FC = (props: any) => {
    const user = JSON.parse(localStorage.getItem("userobject")||'{}');
const [PropertyObject, setState] = useState({ 
  NormalListing:"",
  PremiumListing: "", 


});
const handleChange = (e: { target: { name: any; value: any; }; }) => {
  const { name, value } = e.target;
  setState(prevState => ({
      ...prevState,
      [name]: value
  }));

  setState(prevState => ({
   ...prevState,
   userid: user.id
}));
};

    const { name } = useParams<{ name: string; }>(); 
    const { Column, ColumnGroup } = Table;



  
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonRow class="ion-text-center">
                        <PageHeader
                            className="site-page-header"
                            onBack={()=>{props.history.goBack()}}
                            title="Admin Settings"
                        />
                    </IonRow>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen>
       
                <Space direction="vertical">
                    <IonGrid>
                        <IonRow>
                            <IonCol size="20" style={{ paddingLeft: "40px" }}>
                                <IonCard>
                                    <IonCardHeader>
                                        <h1 className="ion-text-center">Inactive until payment integration is completed</h1>
                                    </IonCardHeader>

                                    <IonCardContent>
                                        <IonRow>
                                        <IonCol>
                                            <p style={{ paddingLeft: "120px" }}>Configure fees amount for "normal listing type" per day</p>
                                    <Input disabled value={PropertyObject.NormalListing} onChange={handleChange}placeholder="" />
                                    <IonRow>
                                        <IonCol size="20" style={{ paddingLeft: "1px" }}>
                                    <Button  disabled style={{ left: "250px" }}  type="primary">Save</Button>
                                    </IonCol>
                                    </IonRow>
                                    </IonCol>
                                    <IonCol>
                                    <p style={{ paddingLeft: "120px" }}>Configure fees amount for "premium listing type" per day</p>
                                    <Input disabled value={PropertyObject.PremiumListing} onChange={handleChange} placeholder="" />
                                    <IonRow>
                                    <IonCol size="20" style={{ paddingLeft: "1px" }}>
                                    <Button  disabled style={{ left: "250px" }} type="primary">Save</Button>
                                    
                                    </IonCol>
                                    </IonRow>
                                    </IonCol>
                                    </IonRow>
                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </Space>
            </IonContent>
        </IonPage>


    );
};

export default AdminSettings;
